"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function _isSome(value) {
    return value !== undefined && value !== null;
}
function _isNone(value) {
    return !_isSome(value);
}
var Option = /** @class */ (function () {
    function Option(value) {
        var _this = this;
        this.value = value;
        /**
         * Checks whether the value is some.
         */
        this.isSome = function () { return _isSome(_this.value); };
        /**
         * Checks whether the value is none.
         */
        this.isNone = function () { return _isNone(_this.value); };
    }
    /**
     * Gets the underlying value. You *must* check whether the value is some or none before getting, as using this on a value that is none **will** throw an error.
     */
    Option.prototype.get = function () {
        if (_isNone(this.value)) {
            throw new Error("Attempted to get an option value that was none. Use Option.isSome to check if an option has a value before using it.");
        }
        return this.value;
    };
    /**
     * Maps the value to another value. Will only run if the value is some.
     */
    Option.prototype.map = function (mapper) {
        if (_isSome(this.value)) {
            return Option.ofSome(mapper(this.value));
        }
        return Option.ofNone();
    };
    /**
     * Binds the value to another option. Will only run if the value is some.
     */
    Option.prototype.bind = function (mapper) {
        if (_isSome(this.value)) {
            return mapper(this.value);
        }
        return Option.ofNone();
    };
    /**
     * Passes the value to the given @param fn function where it can the be used for operations that don't require a value to be returned.
     */
    Option.prototype.iter = function (fn) {
        if (_isSome(this.value)) {
            fn(this.value);
        }
        return this;
    };
    /**
     * Executes the given @param fn function when the the option has no value.
     */
    Option.prototype.iterNone = function (fn) {
        if (_isNone(this.value)) {
            fn();
        }
        return this;
    };
    /**
     * Returns the @param defaultValue if the option is none, else returns the option's value.
     */
    Option.prototype.defaultValue = function (defaultValue) {
        if (_isSome(this.value)) {
            return this.value;
        }
        return defaultValue;
    };
    /**
     * Executes the @param fn function if the value is none and returns the result, else returns the option value itself.
     */
    Option.prototype.defaultWith = function (fn) {
        if (_isSome(this.value)) {
            return this.value;
        }
        return fn();
    };
    /**
     * Wraps the @param value in an option.
     */
    Option.ofSome = function (value) {
        if (_isNone(value)) {
            throw new Error("Option.some received a value that was null or undefined.");
        }
        return new Option(value);
    };
    /**
     * Creates an option with no value.
     */
    Option.ofNone = function () {
        return new Option();
    };
    /**
     * Checks whether the value is some.
     */
    Option.isSome = function (option) {
        return option.isSome();
    };
    /**
     * Checks whether the value is none.
     */
    Option.isNone = function (option) {
        return option.isNone();
    };
    /**
     * Gets the underlying value. You *must* check whether the value is some or none before getting, as using this on a value that is none **will** throw an error.
     */
    Option.get = function (option) {
        return option.get();
    };
    /**
     * Returns a curried function that will map the value to another value. Will only run if the value is some.
     */
    Option.map = function (mapper) {
        return function (option) { return option.map(mapper); };
    };
    /**
     * Returns a curried function that will bind the value to another option. Will only run if the value is some.
     */
    Option.bind = function (mapper) {
        return function (option) { return option.bind(mapper); };
    };
    /**
     * Returns a curried function that will pass the value to the given @param fn function where it can the be used for operations that don't require a value to be returned.
     */
    Option.iter = function (fn) {
        return function (option) { return option.iter(fn); };
    };
    /**
     * Returns a curried function that executes the given @param fn function when the the option has no value.
     */
    Option.iterNone = function (fn) {
        return function (option) { return option.iterNone(fn); };
    };
    /**
     * Returns a curried function that will return the @param defaultValue if the option is none, else returns the option's value.
     */
    Option.defaultValue = function (defaultValue) {
        return function (option) { return option.defaultValue(defaultValue); };
    };
    /**
     * Returns a curried function that will execute the @param fn function if the value is none and returns the result, else returns the option's value itself.
     */
    Option.defaultWith = function (fn) {
        return function (option) { return option.defaultWith(fn); };
    };
    return Option;
}());
exports.Option = Option;
//# sourceMappingURL=option.js.map